export { default as NDataTable } from './src/DataTable';
export { dataTableProps } from './src/interface';
